export const moduleColors = {
  greenBase: "rgb(20, 109, 66, 0.7)",
  blueBase: "rgb(143 175 195)",
  amberBase: "rgb(222 167 52)",
  greyBase: "rgb(197 207 205)",
  redBase: "rgb(219 98 67)",
};
